import React from 'react';

type ProgressBarProps = {
    width?: number | string
    height?: number | string
    percent: number
    className?: string
    bgColor: string
    fillColor: string
    onClick?: () => void
    borderRadius?: number
    style?: React.CSSProperties
}

const ProgressBar = (props: ProgressBarProps) => {
    const {
        height,
        percent = 0,
        className,
        width = '100%',
        bgColor,
        fillColor,
        onClick,
        borderRadius,
        style
    } = props;

    return (
        <div
            onClick={onClick}
            style={{
                width,
                height,
                background: bgColor,
                borderRadius,
                cursor: onClick ? 'pointer' : 'default',
                ...style
            }}
            className={className}
        >
            <div style={{ width: `${percent > 100 ? 100 : percent}%`, background: fillColor, borderRadius, height }} />
        </div>
    )
}

export default ProgressBar;